export default "__VITE_ASSET__C071hyeg__"